/**
 * Normalizes a campaign URL slug for Société pages (`/:region/societe/:slug`).
 * Accepts a raw slug or a full/partial URL and returns a lowercase kebab-case segment.
 */
export function extractCampaignSlugFromUrl(input: string): string | null {
  const candidate = input.trim();
  if (!candidate.includes('/') && !candidate.includes('://')) {
    return null;
  }

  try {
    const pathname = candidate.includes('://') ? new URL(candidate).pathname : candidate.split('?')[0].split('#')[0];

    const segments = pathname.split('/').filter(Boolean);
    const societeIndex = segments.findIndex((segment) => segment.toLowerCase() === 'societe');

    if (societeIndex >= 0 && segments[societeIndex + 1]) {
      return segments[societeIndex + 1];
    }

    return segments[segments.length - 1] ?? null;
  } catch {
    return null;
  }
}

export function normalizeCampaignSlug(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';

  const extracted = extractCampaignSlugFromUrl(trimmed);
  const base = extracted ?? trimmed;

  return base
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isValidCampaignSlug(slug: string): boolean {
  const normalized = normalizeCampaignSlug(slug);
  return normalized.length > 0 && normalized === slug.trim();
}
